import React, { useState } from "react";

import { Table, TableRow, TableCell, Collapse, Box, TableBody } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";


const Expand = ({ row, index }) => {

    const [isExpand, setExpand] = useState(false);

    const onExpandPress = () => {
        setExpand(!isExpand);
    }

    console.log("here", isExpand);

    const isEvenRow = index % 2 === 0;
    const rowBackgroundColor = isEvenRow ? "#fff" : "#f1f1ff";

    return (
        <>
            <TableRow className={`prod-table-bodyRow ${isExpand ? "expanded" : ""}`}
                style={{ backgroundColor: rowBackgroundColor }}>
                <TableCell className="prod-table-bodyRowCell">
                    <div
                        className={`status-indicator ${row.status === "Packed"
                            ? "medium"
                            : row.status === "Work in Progress"
                                ? "high"
                                : "low"
                            }`}
                    ></div>
                </TableCell>
                <TableCell className="prod-table-bodyRowCell">  {row.status}
                </TableCell>
                <TableCell className="prod-table-bodyRowCell">{row.days_left}</TableCell>
                <TableCell className="prod-table-bodyRowCell">{row.order_id}</TableCell>
                <TableCell className="prod-table-bodyRowCell">{row.customer_name}</TableCell>
                <TableCell className="prod-table-bodyRowCell">{row.order_quantity}</TableCell>
                <TableCell className="prod-table-bodyRowCell">{row.packed_quantity}</TableCell>
                <TableCell className="prod-table-bodyRowCell">{row.dispatch_quantity}</TableCell>
                <TableCell style={{ width: "0%" }} className="prod-table-bodyRowCell">
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => onExpandPress(row.order_id)}
                    >
                        {isExpand ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
            </TableRow>
            {isExpand && (
                <TableRow>
                    <TableCell colSpan={9} className="insideProductionTable">

                        <Collapse in={isExpand} timeout="auto" unmountOnExit>
                            <Box className="insideProductionTable">
                                <Table
                                    size="small"
                                    aria-label="purchases"
                                    style={{ borderRadius: "0px" }}
                                >
                                    <TableBody>
                                        <TableRow key={""}>
                                            <TableCell rowSpan={2}
                                                style={{ fontSize: "16px", fontWeight: 500, border: "1px solid #A9B0BD", borderTop: 'none', borderRight: 'none' }}>
                                                DEA0010107
                                            </TableCell>
                                            <TableCell style={{ fontSize: "16px", fontWeight: 500, border: "1px solid #A9B0BD", borderTop: 'none', borderRight: 'none' }}>
                                                Order Date
                                            </TableCell>
                                            <TableCell style={{ fontSize: "16px", fontWeight: 500, border: "1px solid #A9B0BD", borderTop: 'none', borderRight: 'none' }}>
                                                Promise Date
                                            </TableCell>
                                            <TableCell style={{ fontSize: "16px", fontWeight: 500, border: "1px solid #A9B0BD", borderTop: 'none', borderRight: 'none' }}>
                                                Type
                                            </TableCell>
                                            <TableCell style={{ fontSize: "16px", fontWeight: 500, border: "1px solid #A9B0BD", borderTop: 'none', borderRight: 'none' }}>
                                                Size
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ border: "1px solid #A9B0BD" }}>
                                                {row.details.order_date}
                                            </TableCell>
                                            <TableCell style={{ border: "1px solid #A9B0BD" }}>
                                                {row.details.promise_date}
                                            </TableCell>
                                            <TableCell style={{ border: "1px solid #A9B0BD" }}>
                                                {row.details.type}
                                            </TableCell>
                                            <TableCell style={{ border: "1px solid #A9B0BD", borderRight: 'none' }}>
                                                {row.details.size}
                                            </TableCell>
                                        </TableRow>

                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>

                </TableRow>
            )}


        </>
    )
};

export default Expand;